import moment from "moment";
import { axios } from "../../../../lib/axios";

// --------------- response--------------------------------

const newPayload = ({ requestType, patientId, encounterId, text, document, status = "draft", documentName  }) => {
    const currentDateTime = moment().format("YYYY-MM-DDTHH:mm:ss[Z]")
    return {
        resourceType: "ServiceRequest",
        requestType, //lab,referral,diagnostic
        status,
        intent: "order",
        priority: "routine",
        patientId,
        encounterId,
        locationReferenceId: "",
        time: currentDateTime,
        text,
        occurrenceDateTime: currentDateTime,
        documentName: documentName
    }
}

export const createServiceRequest = (payload) => {
    const body = newPayload(payload);
    const patientId = encodeURIComponent(payload.patientId);
    return axios.post(`/servicerequest?patientId=${patientId}`, body);
};

export const editServiceRequest = ({ id, ...payload }) => {
    return axios.put(`/servicerequest/${id}`, { ...payload });
};

export const deleteServiceRequest = (serviceId) => {
    return axios.put(`/servicerequest/${serviceId}`, {
        active: false
    });
};

export const sendSFT = (payload) => {
    return axios.post(`/securefiletransfer`, payload);
};

export { buildInternalReferralPayload, buildWaitingRoomPayload } from "../../ServiceRequest/internalReferralPayload";

export const createInternalReferral = (payload) => {
    const patientId = payload?.patient?.id;
    const query = patientId ? `?patientId=${encodeURIComponent(patientId)}` : "";
    return axios.post(`/servicerequest/refer${query}`, payload);
};
